<!--
 * @Author: Haoxiwei 1078734933@qq.com
 * @Date: 2023-07-27 16:39:35
 * @LastEditors: Haoxiwei 1078734933@qq.com
 * @LastEditTime: 2024-02-22 17:31:06
 * @FilePath: /wemeet-iam/Users/hvv/weMeetSpace/WeMeet_admin_project/wemeet-admin/src/views/brandProduct/components/editSort.vue
 * @Description: 
 * Copyright (c) 2023 by WeMeet, All Rights Reserved. 
-->
<template>
  <el-dialog v-model="dialogFormVisible" :title="title" width="500px" @close="close">
    <el-form ref="formRef" label-width="80px" :model="form" :rules="rules">
      <el-form-item label="排序" prop="sortNumber">
        <el-input v-model="form.sortNumber" />
      </el-form-item>
    </el-form>
    <template #footer>
      <el-button @click="close">取 消</el-button>
      <el-button type="primary" @click="save">确 定</el-button>
    </template>
  </el-dialog>
</template>

<script>
  import { defineComponent, getCurrentInstance, onMounted, reactive, toRefs } from 'vue'
  import { editBrandProductSort, getBrandProductDetail } from '@/api/brand'

  export default defineComponent({
    name: 'EditSort',
    emits: ['fetch-data'],
    setup(props, { emit }) {
      const { proxy } = getCurrentInstance()

      const state = reactive({
        formRef: null,
        treeRef: null,
        checkMenu: [],
        form: {
          sortNumber: 0,
        },
        rules: {
          sortNumber: [{ required: true, trigger: 'blur', message: '请输入排序' }],
        },
        title: '',
        dialogFormVisible: false,
        list: [],
        flag: '',
        nowSort: '',
      })

      const showEdit = async (row, flag) => {
        const { data } = await getBrandProductDetail({
          exhibitCode: row.exhibitCode,
        })
        state.flag = flag
        state.form = Object.assign({}, data)

        console.log(row, '-===')
        state.form.sortNumber = row.selfSort
        state.dialogFormVisible = true
      }
      const close = () => {
        state['formRef'].resetFields()
        state.form = {
          sort: 0,
        }
        state.dialogFormVisible = false
      }

      const save = () => {
        state['formRef'].validate(async (valid) => {
          if (valid) {
            if (state.flag == 'inside') {
              state.form.selfSort = state.form.sortNumber
            } else {
              state.form.sort = state.form.sortNumber
            }
            let { data } = await editBrandProductSort(state.form)
            proxy.$baseMessage(`修改成功`, 'success', 'vab-hey-message-success')
            emit('fetch-data')
            close()
          }
        })
      }
      return {
        ...toRefs(state),
        showEdit,
        close,
        save,
      }
    },
  })
</script>

<style lang="scss" scoped>
  .vab-tree-border {
    height: 200px;
    padding: $base-padding;
    overflow-y: auto;
    border: 1px solid #dcdfe6;
    border-radius: $base-border-radius;
  }
</style>
